import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PortalBalanceResponse } from "../../features/portal/contracts/PortalBalanceResponse";
import { formatMoney } from "../../features/billing/utils/money";
import { getDisplayLocale } from "../../features/utils/timezoneUtils";

interface PortalOverdueBannerProps {
  balance: PortalBalanceResponse | undefined;
  /** The Money section, with the shown ward kept on the link. */
  moneyTo: string;
}

/** One red line on Next when any payment is overdue, with the way to Money where the balance lives. */
const PortalOverdueBanner = ({ balance, moneyTo }: PortalOverdueBannerProps) => {
  const { t } = useTranslation();

  if (!balance || balance.overdueCount === 0) {
    return null;
  }

  const total = balance.overdueCurrency
    ? formatMoney(balance.overdueTotalMinorUnits, balance.overdueCurrency, getDisplayLocale())
    : null;

  return (
    <div
      role="alert"
      className="mb-6 rounded-2xl bg-red-100 p-4 text-red-800 dark:bg-red-900/30 dark:text-red-300"
    >
      <p>
        <span className="font-semibold">
          {total
            ? t("portal.overdueBannerTitle", "{{count}} overdue payment · {{total}}", {
                count: balance.overdueCount,
                total,
              })
            : t("portal.overdueBannerTitleNoTotal", "{{count}} overdue payment", {
                count: balance.overdueCount,
              })}
        </span>
        <span aria-hidden="true"> · </span>
        <Link to={moneyTo} className="underline underline-offset-4">
          {t("portal.overdueBannerLink", "See payments")}
        </Link>
      </p>
    </div>
  );
};

export default PortalOverdueBanner;
